import * as React from "react";
import * as SliderPrimitive from "@radix-ui/react-slider";

import { cn } from "@/lib/utils";

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>
>(({ className, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn(
      "relative flex w-full touch-none select-none items-center py-4",
      className
    )}
    {...props}
  >
    <SliderPrimitive.Track className="relative h-3 w-full grow overflow-hidden rounded-full bg-secondary cursor-pointer transition-all">
      <SliderPrimitive.Range className="absolute h-full bg-primary transition-all duration-150 ease-out" />
    </SliderPrimitive.Track>
    <SliderPrimitive.Thumb 
      className="block h-7 w-7 rounded-full border-3 border-primary bg-background shadow-lg ring-offset-background transition-all duration-150 ease-out hover:scale-125 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 cursor-grab active:cursor-grabbing active:scale-110 touch-manipulation will-change-transform" 
      aria-label="Minimum pris"
    />
    <SliderPrimitive.Thumb 
      className="block h-7 w-7 rounded-full border-3 border-primary bg-background shadow-lg ring-offset-background transition-all duration-150 ease-out hover:scale-125 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 cursor-grab active:cursor-grabbing active:scale-110 touch-manipulation will-change-transform"
      aria-label="Maximum pris"
    />
  </SliderPrimitive.Root>
));
Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
